import type { ComponentProps, FC, Ref } from 'react';
import { StyleSheet, type StyleProp, type TextInput as NativeTextInput, type TextStyle } from 'react-native';
import { TextInput } from 'react-native-paper';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

type PaperTextInputProps = ComponentProps<typeof TextInput>;

export type EmailFieldHandle = NativeTextInput;

export type Props = {
	label: string;
	ref?: Ref<EmailFieldHandle>;
	value: string;
	hasError?: boolean;
	style?: StyleProp<TextStyle>;
	onChangeText: (value: string) => void;
	onKeyPress?: PaperTextInputProps['onKeyPress'];
	onPressIn?: PaperTextInputProps['onPressIn'];
	onSubmitEditing?: PaperTextInputProps['onSubmitEditing'];
};

const EmailField: FC<Props> = ({
	label,
	ref,
	value,
	hasError = false,
	style,
	onChangeText,
	onKeyPress,
	onPressIn,
	onSubmitEditing,
}) => {
	return (
		<TextInput
			autoCapitalize="none"
			autoCorrect={false}
			error={hasError}
			inputMode="email"
			label={label}
			ref={ref}
			style={[styles.input, style]}
			value={value}
			onChangeText={onChangeText}
			onKeyPress={onKeyPress}
			onPressIn={onPressIn}
			onSubmitEditing={onSubmitEditing}
		/>
	);
};

const styles = StyleSheet.create({
	input: {
		backgroundColor: Colors.gray100,
		zIndex: Dimens.zIndexOverlay,
	},
});

export default EmailField;
